export default "__VITE_ASSET__DimD16nG__";